import './index.css';
import Button from '@eduzz/houston-ui/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';

interface IProps {
  title?: string;
  buttonOk?: string;
  buttonOkColor?: string;
  buttonCancel?: string;
  open: boolean;
  onClose: any;
  onOk: any;
  loading?: boolean;
  loadingColor?: string;
  buttonOkDisabled?: boolean;
}

class ModalActions extends Component<IProps> {
  render() {
    return (
      <Dialog open={this.props.open} maxWidth={'xs'} fullWidth>
        <DialogTitle>{this.props.title ?? 'Deseja realmente executar esta ação?'}</DialogTitle>
        <DialogContent>
          <DialogContentText>{this.props.children}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='default' variant='text' onClick={this.props.onClose} style={{ marginBottom: '0.5rem' }} disabled={this.props.loading}>
            {this.props.buttonCancel ? this.props.buttonCancel : 'Cancelar'}
          </Button>
          <Button
            color='secondary'
            variant='contained'
            onClick={this.props.onOk}
            style={{ marginBottom: '0.5rem', background: this.props.buttonOkColor }}
            disabled={this.props.loading || this.props.buttonOkDisabled}
            id='modal-button-confirm'
          >
            {this.props.buttonOk ? this.props.buttonOk : 'Ok'}
            {this.props.loading && (
              <CircularProgress size={18} style={{ marginLeft: 12, color: this.props.loadingColor ? this.props.loadingColor : '#ccc' }} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ModalActions;
